import request from "@/api";

export function listCatalog(data) {
    return request({
        url: '/api/catalog/getCatalogList',
        method: 'get',
        params: data
    })
}

export function listCatalogCache(data) {
    return request({
        url: '/api/catalog/getCatalogCacheList',
        method: 'get',
        params: data
    })
}

export function saveCatalog(data) {
    return request({
        url: '/api/catalog/saveCatalog',
        method: 'post',
        data: data
    })
}

export function deleteCatalog(data) {
    return request({
        url: '/api/catalog/deleteCatalog',
        method: 'post',
        data: data
    })
}

export function exportCatalog(data) {
    return request({
        url: '/api/catalog/export',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}